// removed by extract-text-webpack-plugin
module.exports = {"dialog":"app-pages-Employees-Staff-PinRequiredModal-__PinRequiredModal___3-InV","title":"app-pages-Employees-Staff-PinRequiredModal-__PinRequiredModal___3N2Ly","body":"app-pages-Employees-Staff-PinRequiredModal-__PinRequiredModal___vpNcb"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/PinRequiredModal/PinRequiredModal.css
// module id = 2334
// module chunks = 0